import SignupLayout from '../ui-components/SignupLayout';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SignupPage.module.css';
import Button, { ButtonType } from '../general-components/Button';
import { confirmEmail } from '../../services/apiService';

const FailedToConfirm = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <h3>{t('signup.confirmEmail.failed.title')}</h3>
            <p>{t('signup.confirmEmail.failed.contact')}</p>
            <Button
                className={styles.button}
                type={ButtonType.primary}
                onClick={() => {
                    window.location.href = '/';
                }}
            >
                {t('signup.confirmEmail.failed.button')}
            </Button>
        </React.Fragment>
    );
};

const Confirmed = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <h3>{t('signup.confirmEmail.confirmed.title')}</h3>
            <p style={{ marginBottom: '30px' }}>
                {t('signup.confirmEmail.confirmed.description')}
                <br />
                <br />
                {t('signup.confirmEmail.confirmed.additionalAccess')}
            </p>
            <Button
                className={styles.button}
                type={ButtonType.submit}
                onClick={() => {
                    const win = window.open(
                        process.env.REACT_APP_MEETING_LINK,
                        '_blank'
                    );
                    window.location.href = '/';
                    win.focus();
                }}
            >
                {t('signup.confirmEmail.confirmed.buttons.bookMeeting')}
            </Button>
            <Button
                className={styles.button}
                type={ButtonType.primary}
                onClick={() => {
                    window.location.href = '/';
                }}
            >
                {t('signup.confirmEmail.confirmed.buttons.returnToLogin')}
            </Button>
        </React.Fragment>
    );
};

const ConfirmEmailPage: React.FC = () => {
    const { t } = useTranslation();
    const [confirmed, setConfirmed] = useState(false);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get('id');

    const emailConfirmation = async () => {
        console.log(id);
        const emailConfirmed = await confirmEmail(id);
        console.log(emailConfirmed);
        setConfirmed(emailConfirmed);
    };

    useEffect(() => {
        emailConfirmation();
    }, []);

    return (
        <SignupLayout>
            {confirmed && <Confirmed />}
            {!confirmed && <FailedToConfirm />}
        </SignupLayout>
    );
};

export default ConfirmEmailPage;
